import React from 'react';
import { useCss } from 'app/utils/css';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';

export enum H1Variant {
  H1_BASE_STYLE,
  H1_HTTP_STATUS_STYLE,
}

const baseStyle = {
  fontSize: '2.4em',
  fontWeight: 600,
  lineHeight: '1.4',
  margin: '0.4em 0',
};

const httpStatusBaseStyle = {
  fontSize: '13em',
  lineHeight: '1',
  margin: '0',
  color: '#c9c9c9',
};

const H1 = ({ variant = H1Variant.H1_BASE_STYLE, children }: {variant?: H1Variant, children: React.ReactNode }) => {
  const css = useCss();
  const breakpoint = usePageBreakpoint();
  const isNarrow = breakpoint <= NumericBreakpoint.Narrow;

  return (
    <h1 className={css(`h1`, [
      variant === H1Variant.H1_BASE_STYLE && {
        ...baseStyle,
      },
      variant === H1Variant.H1_HTTP_STATUS_STYLE && {
        ...httpStatusBaseStyle,
        fontSize: isNarrow ? '10em' : '13em',
      },
    ])}
    >
      {children}
    </h1>
  );
};

export default H1;
